import { Button } from '../components/ui/button';
import { Link } from 'react-router-dom';
import { useEffect } from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { usePageMeta } from '../hooks/usePageMeta';
import { useJobPostingStructuredData } from '../hooks/useStructuredData';

export const CareersPage = () => {
  usePageMeta({
    title: 'Careers - Healthcare Job Openings',
    description: 'Browse open healthcare positions including travel nursing, allied health, and non-clinical roles. Apply today and start your healthcare career with Digitive Health.',
    path: '/careers',
  });
  useJobPostingStructuredData();

  useEffect(() => {
    window.scrollTo(0, 0);
    
    // Load CEIPAL ATS Script
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'https://jobsapi.ceipal.com/APISource/widget.js';
    script.setAttribute('data-ceipal-api-key', 'TnB4OTRhUm9aOGVDT1hEU2xTVXViQT09');
    script.setAttribute('data-ceipal-career-portal-id', 'Z3RkUkt2OXZJVld2MjFpOVRSTXoxZz09');
    script.async = true;
    document.body.appendChild(script);

    return () => {
      // Cleanup script on unmount
      const existingScript = document.querySelector('script[src="https://jobsapi.ceipal.com/APISource/widget.js"]');
      if (existingScript) {
        existingScript.remove();
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-white" data-testid="careers-page">
      {/* Header */}
      <Header />

      {/* Hero Section */}
      <section className="pt-28 pb-16 bg-secondary relative overflow-hidden">
        <div className="container-width">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            {/* Left Content */}
            <div className="text-left">
              <span className="inline-block text-sm font-medium tracking-widest uppercase text-primary/60 mb-4">
                Careers
              </span>
              <h1 className="text-4xl md:text-5xl font-bold tracking-tight text-foreground mb-6">
                Find Your Next Opportunity in Healthcare
              </h1>
              <p className="text-lg text-muted-foreground">
                Join our network of healthcare professionals and discover rewarding career opportunities across the nation.
              </p>
            </div>
            
            {/* Right Image */}
            <div className="relative hidden lg:block">
              <div className="rounded-2xl overflow-hidden shadow-xl">
                <img
                  src="https://static.prod-images.emergentagent.com/jobs/3c79fc15-7acb-4945-a01c-dd7a9cf21362/images/c0359f2d721bfc4d15a80e0f3092ce92a24179ddbed26fa6b3a821ee3a8e11fa.png"
                  alt="Diverse group of healthcare professionals - nurses, doctors, and allied health workers"
                  className="w-full h-[350px] object-cover object-top"
                  data-testid="careers-hero-image"
                />
              </div>
              {/* Decorative elements */}
              <div className="absolute -bottom-4 -left-4 w-24 h-24 bg-primary/20 rounded-full blur-xl" />
              <div className="absolute -top-4 -right-4 w-32 h-32 bg-primary/10 rounded-full blur-2xl" />
            </div>
          </div>
        </div>
      </section>

      {/* ATS Iframe Section */}
      <section className="section-padding" data-testid="ats-iframe-section">
        <div className="container-width">
          <div className="bg-secondary/50 rounded-2xl p-4 md:p-8">
            <div className="bg-white rounded-xl shadow-sm overflow-hidden min-h-[600px]">
              {/* CEIPAL ATS Job Board */}
              <div 
                id="ats-embed-container"
                className="w-full"
                data-testid="ats-embed-container"
              >
                <div id="example-widget-container"></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact CTA */}
      <section className="py-16 bg-primary text-white">
        <div className="container-width text-center">
          <h2 className="text-3xl font-bold mb-4">Can't Find the Right Role?</h2>
          <p className="text-white/80 mb-8 max-w-xl mx-auto">
            Submit your resume and we'll reach out when a matching opportunity becomes available.
          </p>
          <Link to="/#contact">
            <Button 
              className="bg-white text-primary hover:bg-white/90 rounded-full px-8 py-6 text-base"
              data-testid="contact-us-btn"
            >
              Contact Us
            </Button>
          </Link>
        </div>
      </section>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default CareersPage;
